import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAppContext } from '../context/AppContext';
// --- *** IMPORT NEW ICON *** ---
import { GiMicroscope } from 'react-icons/gi'; 
import { FaSun, FaMoon } from 'react-icons/fa';

const Nav = styled.nav`
  background: ${props => props.theme.colors.surface};
  border-bottom: 1px solid ${props => props.theme.colors.surface2};
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  box-shadow: ${props => props.theme.shadow};
`;

const Logo = styled(NavLink)`
  color: ${props => props.theme.colors.accent};
  font-size: 1.5rem;
  font-weight: bold;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;

const StyledLink = styled(NavLink)`
  color: ${props => props.theme.colors.textSecondary};
  text-decoration: none;
  font-size: 1rem;
  font-weight: 500;
  padding: 1.25rem 0;
  border-bottom: 2px solid transparent;

  &.active {
    color: ${props => props.theme.colors.accent};
    border-bottom: 2px solid ${props => props.theme.colors.accent};
  }
  
  &:hover {
    color: ${props => props.theme.colors.text};
  }
`;

const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const ControlButton = styled.button`
  background: none;
  border: 1px solid ${props => props.theme.colors.surface2};
  color: ${props => props.theme.colors.textSecondary};
  padding: 0.5rem;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${props => props.theme.colors.text};
    border-color: ${props => props.theme.colors.textSecondary};
  }
`;

const LogoutButton = styled(ControlButton)`
  border-color: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.primary};
  padding: 0.5rem 1rem;
  &:hover {
    background: ${props => props.theme.colors.primary};
    color: white;
  }
`;

const AppLayout = ({ children }) => {
  const { logout, themeMode, toggleTheme } = useAppContext();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch {
      console.error("Failed to log out");
    }
  };

  return (
    <>
      <Nav>
        <NavLinks>
          {/* --- *** USE NEW ICON *** --- */}
          <Logo to="/create"><GiMicroscope /> Codex Vitae</Logo>
          <StyledLink to="/create">Create</StyledLink>
          <StyledLink to="/test">Test</StyledLink>
          <StyledLink to="/evolve">Evolve</StyledLink>
          <StyledLink to="/lineage">Lineage</StyledLink>
          <StyledLink to="/gallery">Gallery</StyledLink>
        </NavLinks>
        <Controls>
          <ControlButton onClick={toggleTheme} aria-label="Toggle theme">
            {themeMode === 'dark' ? <FaSun /> : <FaMoon />}
          </ControlButton>
          <LogoutButton onClick={handleLogout}>Logout</LogoutButton>
        </Controls>
      </Nav>
      <main style={{ padding: '2rem' }}>{children}</main>
    </>
  );
};

export default AppLayout;